import { Box } from '@chakra-ui/react'
import { AppContainer } from 'components/ui/appContainer'
import { StaticContent } from 'components/ui/staticContent'
import { TermsQuery } from 'generated/graphql'
import { FC } from 'react'

export type TermsPageProps = {
  terms: TermsQuery['terms']
}

export const TermsPage: FC<TermsPageProps> = ({ terms }) => {
  return (
    <>
      <AppContainer>
        <Box pt={12} pb={20}>
          <StaticContent title={terms.title} body={terms.body} />
        </Box>
      </AppContainer>
    </>
  )
}
